import { FC, ReactNode, useEffect, useState } from "react";
import { useOidcAuthenticationService } from "./useOidcAuthenticationService";
import { User } from "oidc-client";

export interface AccessTokenProviderProps {
  children: (accessToken: string) => ReactNode;
}

export const OidcAccessTokenProvider: FC<AccessTokenProviderProps> = (
  props
) => {
  const authService = useOidcAuthenticationService();
  const [user, setUser] = useState<User | null>(null);
  const [accessToken, setAccessToken] = useState<string | undefined>(undefined);

  useEffect(() => {
    authService.getUser().then((user) => {
      setUser(user);
      setAccessToken(user?.access_token);
    });
  }, [authService]);

  useEffect(() => {
    if (user?.expires_at) {
      const expiresAtMs = user.expires_at * 1000;
      const bufferMs = 5 * 60 * 1000;
      const now = new Date().getTime();
      const sleep = expiresAtMs - now - bufferMs;

      console.log(
        "OidcAccessTokenProvider - Setting next user token refresh in ms/min: ",
        sleep,
        sleep / 1000.0 / 60.0
      );

      if (expiresAtMs < now) return;

      setTimeout(() => {
        console.log(
          "OidcAccessTokenProvider - Refreshing user token that expires at " +
            user.expires_at
        );
        authService.refreshToken().then((user) => {
          setUser(user);
          setAccessToken(user?.access_token);
        });
      }, Math.max(sleep, 0));
    }
  }, [authService, user?.expires_at]);

  return <>{props.children(accessToken ?? "")}</>;
};
